export default function Checkbox() {
    return {
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    // Default color when unchecked
                    color: 'var(--grey-400, #bdbdbd)',
                    
                    // Controlling the size of the checkbox icon
                    '& .MuiSvgIcon-root': {
                        fontSize: '24px',
                    },

                    // State: When Checked
                    '&.Mui-checked': {
                        color: '#04253a',
                    },

                    // State: When Disabled
                    // '&.Mui-disabled': {
                    //     color: 'var(--grey-300, #e0e0e0)',
                    // },
                    
                    // Hover effect
                    '&:hover': {
                        backgroundColor: 'rgba(20, 121, 187, 0.04)',
                    }
                },
            }
        }
    };
}